import { useState } from 'react';
import { BottomSheet } from './BottomSheet';
import { Wind, Cable, Spline } from 'lucide-react';

export function AddLineSheet({ onClose, onAddLine, searchLink, onBack }) {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [selectedObject, setSelectedObject] = useState(null);
  const [error, setError] = useState('');

  const handleSearch = async (text) => {
    setQuery(text);
    setSelectedObject(null);
    if (text.length < 2) {
      setResults([]);
      return;
    }
    try {
      const response = await fetch(`${searchLink}${encodeURIComponent(text)}`);
      const data = await response.json();
      setResults(data);
    } catch (e) {
      console.error(e);
    }
  };

  const handleSelect = (obj) => {
    setSelectedObject(obj);
    setQuery(obj.name);
    setResults([]);
    setError('');
  };

  const handleAdd = (typecode) => {
    if (!selectedObject) {
      setError('Выберите объект соединения');
      return;
    }
    onAddLine(selectedObject, typecode);
    onClose();
  };

  const LINE_TYPES = [
    { typecode: '8', label: 'Воздушная', icon: <Wind size={16} /> },
    { typecode: '7', label: 'Кабельная', icon: <Cable size={16} /> },
    { typecode: '7c', label: 'Кривая кабельная', icon: <Spline size={16} /> },
  ];

  return (
    <BottomSheet title="Добавить линию" onClose={onClose} open={true} onBack={onBack}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>

        {/* Поиск */}
        <div>
          <label style={{ fontSize: '13px', color: '#888', display: 'block', marginBottom: '8px' }}>
            Выберите объект соединения
          </label>
          <input
            type="text"
            value={query}
            onChange={(e) => handleSearch(e.target.value)}
            placeholder="Поиск..."
            style={{
              width: '100%',
              padding: '12px 16px',
              fontSize: '15px',
              border: '1px solid #e5e5e5',
              borderRadius: '12px',
              background: '#f9f9f9',
              boxSizing: 'border-box',
              outline: 'none'
            }}
          />

          {/* Список результатов */}
          {results.length > 0 && (
            <div style={{
              marginTop: '4px',
              border: '1px solid #f0f0f0',
              borderRadius: '12px',
              overflow: 'hidden',
              maxHeight: '180px',
              overflowY: 'auto',
              boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
            }}>
              {results.map((obj, index) => (
                <div
                  key={obj.id}
                  onClick={() => handleSelect(obj)}
                  style={{
                    padding: '12px 16px',
                    fontSize: '14px',
                    color: '#1a1a1a',
                    borderBottom: index !== results.length - 1 ? '1px solid #f5f5f5' : 'none',
                    cursor: 'pointer',
                    background: 'white'
                  }}
                >
                  {obj.name}
                </div>
              ))}
            </div>
          )}

          {/* Выбранный объект */}
          {selectedObject && (
            <div style={{
              marginTop: '8px',
              padding: '10px 14px',
              background: '#eff6ff',
              borderRadius: '10px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}>
              <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#3b82f6' }} />
              <span style={{ fontSize: '14px', color: '#1d4ed8', fontWeight: 500 }}>
                {selectedObject.name}
              </span>
            </div>
          )}

          {error && (
            <span style={{ fontSize: '13px', color: '#ef4444', marginTop: '4px', display: 'block' }}>
              {error}
            </span>
          )}
        </div>

        {/* Тип линии */}
        <div>
          <label style={{ fontSize: '13px', color: '#888', display: 'block', marginBottom: '8px' }}>
            Тип линии
          </label>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            {LINE_TYPES.map((type) => (
              <button
                key={type.typecode}
                onClick={() => handleAdd(type.typecode)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  padding: '14px',
                  borderRadius: '12px',
                  background: '#f5f5f5',
                  border: 'none',
                  fontSize: '14px',
                  fontWeight: 500,
                  color: '#1a1a1a',
                  cursor: 'pointer'
                }}
              >
                {type.icon}
                {type.label}
              </button>
            ))}
          </div>
        </div>

      </div>
    </BottomSheet>
  );
}